import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ResourceViewerState {
    isOpen: boolean;
}
const initialState: ResourceViewerState = {
    isOpen: false,
};
const ResourceViewerSlice = createSlice({
    name: 'ResourceViewer',
    initialState,
    reducers: {
        setResourceViewerOpen: (state, action: PayloadAction<boolean>) => {
            state.isOpen = action.payload;
        },
    },
});

export const { setResourceViewerOpen } = ResourceViewerSlice.actions;
export default ResourceViewerSlice.reducer;
